import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
  > div:nth-child(4) {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
`

export const TabsContainer = styled.div`
  margin-left: -${props => props.theme.spacing.sp12};
  margin-right: -${props => props.theme.spacing.sp64};
`
